import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PcMilerService } from "./pcMiler.service";

@Injectable({ providedIn: "root" })
export class PcMilerResolver {
  constructor(private PcMilerService: PcMilerService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.PcMilerService.getCurrentSetup();
  }
}
